import React from 'react'

import PropTypes from 'prop-types'

import { Container, Box } from '@mui/material'
import { darkTheme, lightTheme } from 'themes/theme'
import DocUploadHeader from 'components/Headers/DocUploadHeader'
import { NEW_CONTAINER_WIDTH } from 'constants/layoutConstant'

function DocUploadLayout({ theme, children }) {
    const useTheme = theme === 'dark' ? darkTheme : lightTheme

    return (
        <Box
            sx={{
                height: 'inherit',
                position: 'relative'
            }}
        >
            <DocUploadHeader />
            <Box className="doc-upload__container" backgroundColor={'background.default'}>
                <Container
                    disableGutters
                    sx={{
                        backgroundColor: useTheme.palette.background.default,
                        display: 'grid',
                        gap: 4,
                        justifyItems: 'center',
                        maxWidth: { lg: NEW_CONTAINER_WIDTH },
                        px: { xs: 1, md: 14, lg: 14 },
                        py: { xs: 0 },
                        wordBreak: 'break-word'
                    }}
                >
                    {children}
                </Container>
            </Box>
        </Box>
    )
}

DocUploadLayout.propTypes = {
    theme: PropTypes.string,
    children: PropTypes.node
}

export default DocUploadLayout
